export const Footer = () => (
  <footer className="border-t border-white/10 bg-zinc-950">
    <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
      <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
        <div className="max-w-sm">
          <span className="font-display text-2xl font-900 tracking-tighter text-white">LAMOTTA</span>
          <p className="mt-3 text-sm text-zinc-500">Premium Pokémon &amp; trading cards for serious collectors. Authenticity guaranteed on every pull.</p>
        </div>
        <div className="grid grid-cols-2 gap-10 text-sm">
          <div>
            <p className="overline mb-3 text-zinc-500">Shop</p>
            <ul className="space-y-2 text-zinc-400">
              <li>Pokémon</li><li>Sealed Product</li><li>Sports Cards</li>
            </ul>
          </div>
          <div>
            <p className="overline mb-3 text-zinc-500">Company</p>
            <ul className="space-y-2 text-zinc-400">
              <li>About</li><li>Grading</li><li>Contact</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="mt-12 border-t border-white/5 pt-6 text-xs text-zinc-600">© 2026 LaMotta. All rights reserved.</div>
    </div>
  </footer>
);
